/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал взаимодействия с внешними партнёрами IoT
 */

/**
 * Сервис для отправки команд и сообщений внешним партнёрам IoT
 */
export class IotConnectManageServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Зачем.
   * Ключ отправляет внешнему партнёру факт изменения состояния устройства.
   * В данном случае имеется в виду переход состояния домофона из состояния \"нет вызова в квартиру\" -> \"есть вызов в квартиру\".
   * Метод доступен для: admin
   */
  PostManageState = (req?: PostManageStateRequestDto, init?: RequestInit): Promise<PostManageStateResponseDto> => {
    return fm.request<PostManageStateRequestDto, PostManageStateResponseDto>(`${this.host}/iot_connect/api/v1/manage/state`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод разъединения аккаунтов.
   * Метод доступен для: admin
   */
  PutManageUserDetach = (req: PutManageUserDetachRequestDto, init?: RequestInit): Promise<PutManageUserDetachResponseDto> => {
    return fm.request<PutManageUserDetachRequestDto, PutManageUserDetachResponseDto>(`${this.host}/iot_connect/api/v1/manage/user/${encodeURIComponent(req.userId)}/detach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Сообщение об изменении состояния устройства (домофона)
 */
export type PostManageStateRequestDto = {
  /**
   * Ключ состояния
   */
  key?: string
}
/**
 * Ответ
 */
export type PostManageStateResponseDto = {
}
/**
 * Запрос метода разъединения аккаунтов
 */
export type PutManageUserDetachRequestDto = {
  /**
   * Идентификатор пользователя
   */
  userId: number
}
/**
 * Ответ на запрос метода разъединения аккаунтов
 */
export type PutManageUserDetachResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Сообщение об изменении состояния устройства (домофона)
   */
  "PostManageStateRequest": {
    "kind": "class",
    "text": "Сообщение об изменении состояния устройства (домофона)",
    "fields": {
      /**
       * Ключ состояния
       */
      "key": {
        "type": "string",
        "text": "Ключ состояния",
      },
    },
  },
  /**
   * Ответ
   */
  "PostManageStateResponse": {
    "kind": "class",
    "text": "Ответ",
  },
  /**
   * Запрос метода разъединения аккаунтов
   */
  "PutManageUserDetachRequest": {
    "kind": "class",
    "text": "Запрос метода разъединения аккаунтов",
    "fields": {
      /**
       * Идентификатор пользователя
       */
      "userId": {
        "type": "int32",
        "text": "Идентификатор пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос метода разъединения аккаунтов
   */
  "PutManageUserDetachResponse": {
    "kind": "class",
    "text": "Ответ на запрос метода разъединения аккаунтов",
  },
}